





















































import { Component, Vue } from 'vue-property-decorator'
import md5 from 'js-md5'
import { Base64 } from 'js-base64'
import { encryptOptions } from '@/constant/toolConstant'

@Component({
  name: 'Encryption'
})
export default class extends Vue {
  private canDecode = true
  private encryptAlgorithm = 'Base64'
  private pendingEncode = ''
  private pendingDecode = ''
  private options = encryptOptions

  private handleSelectAlgorithm (algorithm: string) {
    if (algorithm === 'MD5') {
      this.canDecode = false
    } else {
      this.canDecode = true
    }
  }

  private handleEncode () {
    if (this.encryptAlgorithm === 'MD5') {
      this.pendingDecode = md5(this.pendingEncode)
    } else {
      this.pendingDecode = Base64.encode(this.pendingEncode)
    }
  }

  private handleDecode () {
    if (this.encryptAlgorithm === 'Base64') {
      this.pendingEncode = Base64.decode(this.pendingDecode)
    }
  }

  private clear () {
    this.pendingEncode = ''
    this.pendingDecode = ''
  }
}
